module.exports = __webpack_public_path__ + "static/media/printableNar.697e6f3a.png";